import { actions, getters } from '@utils'
import BoardView from '@components/board/BoardView'
import { detach } from '@utils/objects'
import { optionallyCall } from '@utils/functions'
import { toActionName } from '@store/utils'

// TODO: generalize with BoardAdd
// eslint-disable-next-line sonarjs/cognitive-complexity
export default (serviceName, options = {}) => {
  if (typeof options === 'string') options = { redirectTo: options }

  const {
    doFetch = true,
    factory = {},
    isBound = false,
    redirectTo,
    stateKey = serviceName,
    successMessage,

    factoryName = `${stateKey}Factory`,
  } = options

  const actionSuffix = toActionName(serviceName)
  const getFactoryOverride = thisContext => optionallyCall(factory, thisContext, thisContext)
  const suffixAction = prefix => `${prefix}_${actionSuffix}`

  return {
    components: { BoardView },
    data() {
      return {
        hasFetchedRecord: false,
        isSaving: false,
        [stateKey]: detach(this.$store.getters[factoryName](getFactoryOverride(this))),
      }
    },
    watch: {
      recordId: {
        immediate: true,
        handler: 'fetch',
      },
      recordBound(recordBound) {
        if (!recordBound) return
        if (!this.hasFetchedRecord) this.hasFetchedRecord = true
        if (isBound) this.setStateVariable(recordBound)
      },
    },
    computed: {
      recordId() {
        return Number(this.$route.params.id)
      },
      recordBound() {
        return this.queryOne(stateKey, this.recordId)
      },
      ...getters(),
    },
    methods: {
      async save(record) {
        try {
          this.isSaving = true
          await this[suffixAction('PATCH')](record || this[stateKey])

          if (successMessage) {
            this.$store.dispatch('SUCCESS', optionallyCall(successMessage, this, this))
          }

          if (redirectTo === null || this.$route.name === redirectTo) return

          const redirectRoute = optionallyCall(redirectTo, this, this) || `${this.$route.name}s`
          this.$router.push(typeof redirectRoute === 'string'
            ? { name: redirectRoute }
            : redirectRoute)
        } finally {
          this.isSaving = false
        }
      },
      async fetch() {
        if (!this.recordId) return

        if (doFetch) {
          await this.LOAD(() => this[suffixAction('FETCH')](this.recordId))
        }

        this.POST_LOAD(async () => {
          const result = this.query(stateKey, this.recordId)

          if (result) this.setStateVariable(result)
        })
      },
      setStateVariable(result) {
        this[stateKey] = detach({
          ...this.$store.getters[factoryName](getFactoryOverride(this)),
          ...result,
        })
      },
      ...actions(suffixAction('FETCH'), suffixAction('PATCH')),
    },
    render: () => '',
  }
}
